/* 🤖 this file was generated by svg-to-ts */
export const matIconSpaceBar: {
  name: 'space-bar';
  data: string;
} = {
  name: 'space-bar',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M18 9v4H6V9H4v6h16V9h-2z"/></svg>`
};
